<template>
  <div>
    <h3>
      <span>{{ $t("message.script_config_session_management") | title }}</span>
      <span class="wiki-link">
        <a :href="$t('message.script_config_session_management_doc_link')" target="_blank">
          WIKI
        </a>
      </span>
    </h3>

    <div v-if="description">{{description}}</div>

    <b-form>
      <b-form-row v-if="sessionManagementConfig && initConfig">
        <div class="col-4">
          <label class="label label-default">
            {{$t("message.session_management_enabled") | title }}
          </label>
        </div>
        <div class="col-2">
          <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" v-model="sessionManagementEnabled"/>
          </div>
        </div>
        <div v-if="status != null" class="col-4">
          <label class="label label-default">
            <span>
              {{$t("message.session_management_status_short") | title }}:
            </span>
            <span>{{$t('message.status_' + status) | title}}</span>
          </label>
      </b-form-row>

      <b-form-row v-if="initConfig && initConfig.mode == 'cluster'">

        <div class="col-4">
          <label class="label label-default">
            {{$t("message.load_balancer_used") | title }}
          </label>
        </div>
        <div class="col-4">
          <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" v-model="initConfig.load_balancer_used"
              :disabled="!sessionManagementEnabled"/>
          </div>
        </div>
      </b-form-row>

      <b-form-row v-if="initConfig && initConfig.load_balancer_used">
        <div class="col-4">
          <label class="label label-default">
            {{$t("message.load_balancer_fqdn") | title }}
          </label>
        </div>
        <div class="col-8">
          <b-form-input type="url" v-model="initConfig.load_balancer_fqdn"
            v-if="initConfig.load_balancer_used" :disabled="!sessionManagementEnabled"/>
        </div>
      </b-form-row>

      <b-form-row v-if="initConfig && initConfig.mode != 'cluster' && initConfig.guaca == 'configured' && !initConfig.load_balancer_used">
        <div class="col-4">
          <label class="label label-default">
            {{$t("message.session_management_guaca_node_fqdn") | title }}
            <br>(ip: {{initConfig.guaca_node}})
          </label>
        </div>
        <div class="col-8">
          <b-form-input type="url" v-model="initConfig.guaca_node_fqdn" :disabled="!sessionManagementEnabled"/>
        </div>
      </b-form-row>

      <div v-if="initConfig && initConfig.mode == 'cluster'">
        <b-form-row v-for="(nodeIp, nodeIndex) in initConfig.cluster_nodes">
          <div class="col-4">
            <label class="label label-default">
              {{$t("message.session_management_node_fqdn", {node_ip: nodeIp}) | title }}
            </label>
          </div>
          <div class="col-8">
            <b-form-input type="url" v-model="initConfig.cluster_node_fqdns[nodeIndex]"
              :disabled="!sessionManagementEnabled"/>
          </div>
        </b-form-row>
      </div>

      <b-form-row>
        <div class="col-4">
          <label class="label label-default">
            {{$t("message.session_management_terminal_type") | title }}
          </label>
        </div>
        <div class="col-3">
          <b-form-select v-model="sessionManagementConfig.terminal_type" :options="terminalTypeOptions"
            class="form-control text-center" :disabled="!sessionManagementEnabled" @change="onTerminalTypeChanged"/>
        </div>
      </b-form-row>

      <b-form-row>
        <div class="col-4">
          <label class="label label-default">
            {{$t("message.session_management_session_recording") | title }}
          </label>
        </div>
        <div class="col-3">
          <b-form-select v-model="sessionManagementConfig.session_recording"
            :options="sessionRecordingOptions" class="form-control text-center"
            :disabled="!sessionManagementEnabled || sessionManagementConfig.terminal_type=='PMSL'"/>
        </div>
      </b-form-row>

      <b-form-row>
        <div class="col-4">
          <label class="label label-default">
            {{$t("message.session_management_min_session_length") | title }} (ms)
          </label>
        </div>
        <div class="col-3">
          <b-form-select v-model="minSessionLength" :options="minSessionLenghtOptions"
            class="form-control text-center" :disabled="!sessionManagementEnabled"/>
        </div>
      </b-form-row>

      <b-form-row>
        <div class="col-4">
          <label class="label label-default">
            {{$t("message.session_management_connect_update_hour_period") | title }}
          </label>
        </div>
        <div class="col-3">
          <b-form-select v-model="smConnectUpdateHourPeriod" :options="smConnectUpdateHourPeriodOptions"
            class="form-control text-center" :disabled="!sessionManagementEnabled"/>
        </div>
      </b-form-row>

      <b-form-row>
        <div class="col-4">
          <label class="label label-default">
            {{$t("message.session_management_debug") | title }}
          </label>
        </div>
        <div class="col-4">
          <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" v-model="sessionManagementDebug"
            :disabled="!sessionManagementEnabled"/>
          </div>
        </div>
      </b-form-row>

      <div>
        <b-button class="padmin-button submit-button" @click="save"
          :disabled="runInProgress || guacaNodeFqdnRunInProgress" variant="primary">
          <b-spinner v-if="runInProgress || guacaNodeFqdnRunInProgress" small type="grow"/>
          {{$t("message.button_save") | title}}
        </b-button>

      </div>
    </b-form>

    <b-alert :show="formError != null" variant="danger">
      <div> {{formError}} </div>
    </b-alert>

    <b-modal ref="force-save-guaca-node-fqdn-modal" id="force-save-guaca-node-fqdn-modal-id" size="sm"
      ok-only :title="$t('message.force_save')" @ok="saveGuacaNodeFqdn(false)" no-close-on-backdrop>
      {{$t('message.error_' + guacaNodeFqdnFormError, {'details': guacaNodeFqdnFormErrorDetails})}}
    </b-modal>

    <ConsoleOutput v-if="result != null" :result="result" :output="output"/>

  </div>
</template>

<script>
import { get, post } from '../http'
import ConsoleOutput from './ConsoleOutput'
import {validateUrl, validateHostName, validateHostNamePort} from '../util'

export default {
  name: 'SessionManagementConfig',

  components: {
    ConsoleOutput
  },

  data() {
    return {
      initConfig: {},
      sessionManagementConfig: {},
      sessionManagementEnabled: null,
      minSessionLength: 1000,
      result: null,
      output: '',
      runInProgress: false,
      guacaNodeFqdnRunInProgress: false,
      terminalTypeOptions: ['SM', 'PMSL', 'ANY'],
      sessionRecordingOptions: ['YES', 'NO', 'BY ACCOUNT'],
      minSessionLenghtOptions: [...Array(20).keys()].map(i => (i + 1) * 100),
      smConnectUpdateHour: 4,
      smConnectUpdateHourPeriodOptions: [1, 2, 3, 4, 6, 8, 12, 16, 20, 24],
      sessionManagementDebug: false,
      formError: null,
      guacaNodeFqdnFormError: null,
      guacaNodeFqdnFormErrorDetails: null,
      status: null
    }
  },

  mounted() {
    this.loadInitConfig()
    this.load()
  },

  computed: {
    description() {
      let messageLookup = 'message.script_' + this.$route.params.menu + '_' + this.$route.params.script_name + '_description'
      let description = this.$t(messageLookup)
      if (description === messageLookup) {
        return ''
      }
      return description
    }
  },

  methods: {
    onTerminalTypeChanged(newVal) {
      if(newVal == 'PMSL') {
        this.sessionManagementConfig.session_recording = 'NO'
      }
    },

    getUrl() {
      return ('/scripts/config/session_management')
    },

    async save() {
      this.result = null
      this.output = ''
      this.formError = null

      if (this.sessionManagementEnabled) {
        if (this.initConfig['load_balancer_used']) {
          if (this.initConfig['load_balancer_fqdn'] && !validateHostNamePort(this.initConfig['load_balancer_fqdn'])) {
            this.formError = this.$t('message.error_invalid_fqdn_port', {'details': this.initConfig['load_balancer_fqdn']})
            return
          }
        } else {
          if (this.initConfig['guaca_node_fqdn'] && !validateHostName(this.initConfig['guaca_node_fqdn'])) {
            this.formError = this.$t('message.error_invalid_fqdn', {'details': this.initConfig['guaca_node_fqdn']})
            return
          }
        }
      }

      this.saveGuacaNodeFqdn(true)
    },

    saveSessionManagement() {
      this.runInProgress = true
      this.formError = null

      let data = {need_sm: this.sessionManagementEnabled, sm_conf: this.sessionManagementConfig,
        min_session_length: this.minSessionLength, sm_connect_update_hour_period: this.smConnectUpdateHourPeriod,
        sm_debug: this.sessionManagementDebug}

      post(this.getUrl(), data, { 'Content-Type': 'application/json' }).then(
        resp => {
          this.result = resp.data.result
          this.output = resp.data.output
          this.runInProgress = false
          if (resp.data.error) {
            this.formError = resp.data.error
          } else {
            this.load()
          }
        },
        err => {
          this.runInProgress = false
          console.log('err', err)
        }
      )
    },

    saveGuacaNodeFqdn(validate) {
      this.guacaNodeFqdnRunInProgress = true
      this.guacaNodeFqdnFormError = null
      this.guacaNodeFqdnFormErrorDetails = null

      let data = {'guaca_node_fqdn': this.initConfig['guaca_node_fqdn'],
                  'load_balancer_used': this.initConfig['load_balancer_used'],
                  'load_balancer_fqdn': this.initConfig['load_balancer_fqdn'],
                  'cluster_node_fqdns': this.initConfig['cluster_node_fqdns'],
                  'validate': validate}

      post('/guaca_node_fqdn', data, { 'Content-Type': 'application/json' }).then(
        resp => {
          this.guacaNodeFqdnRunInProgress = false
          if (resp.data.error) {
            this.guacaNodeFqdnFormError = resp.data.error
            this.guacaNodeFqdnFormErrorDetails = resp.data.error_details
            this.$root.$emit("bv::show::modal", "force-save-guaca-node-fqdn-modal-id")
          } else {
            this.saveSessionManagement()
          }
        },
        err => {
          this.guacaNodeFqdnRunInProgress = false
          console.log('err', err)
        }
      )
    },

    load() {
      get(this.getUrl()).then(
        resp => {
          this.sessionManagementConfig = resp.data['params']['sm_conf']['value']
          if (!this.sessionManagementConfig) {
            this.sessionManagementConfig = {terminal_type: 'PMSL', session_recording: 'NO'}
          }
          this.sessionManagementEnabled = resp.data['params']['need_sm']['value']
          this.minSessionLength = resp.data['params']['min_session_length']['value']
          this.smConnectUpdateHourPeriod = resp.data['params']['sm_connect_update_hour_period']['value']
          this.sessionManagementDebug = resp.data['params']['sm_debug']['value']
          this.status = resp.data['status']
        },
        err => {
          console.log('err', err)
        }
      )
    },

    loadInitConfig() {
      get("/init/mode").then(
        resp => {
          this.initConfig = resp.data
          if (this.initConfig.load_balancer_used == undefined) {
            this.initConfig.load_balancer_used = false
          }
          if (this.initConfig.load_balancer_fqdn == undefined) {
            this.initConfig.load_balancer_fqdn = ''
          }
          if (!this.initConfig.cluster_node_fqdns) {
            this.initConfig.cluster_node_fqdns = ['', '', '']
          }
        },
        err => {
          console.log("err", err)
        }
      )
    }
  }
}
</script>
